import { useState, type FC } from 'react';
import { Link } from 'react-router-dom';
import './applicationCard.css';
import {type EnvironmentClass, type ApplicationDto} from '@/models/services.ts'
import { Row, Col, Card, CardBody } from 'reactstrap';
import StatisticsSimpleUptime from './statiticsUptimeSimple';
import type { Statistic } from '@/models/statisticsUptime';

type ApplicationCardProps = {
    service: any;
    readonly?: boolean;
    statistic?: Statistic;
    refreshData: () => void;
    toggleBookmarks: (e: any, application: ApplicationDto, currentStatus: boolean) => void;
    editSettings: (e: any, application: ApplicationDto) => void;
    showWarning: () => void;
};

const getStatusIcon = (status: string) =>  {
  return `card card-raising card-bordered m-2 mb-2 mt-2 w-100 card-${status === 'Healthy' ? 'healthy' : status === 'Unhealthy' ? 'unhealthy' :'degraded' }`;
}

const OpenWindow = (e: any, url: string) => {
  window.open(url, '_blank')?.focus();
  e.stopPropagation();
  e.preventDefault();
  return false;
}
const checkAccessibility = (e: any, isConfigured: boolean, func: any) => {
  if (!isConfigured) {
    func();
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
  return true;
}
const DisplayEnvironments = (key: string, environments: EnvironmentClass[], isConfigured: any, showWarning: () => void) => {

  return environments?.map(({ name, status, statusPingdom, urls }) =>
    statusPingdom != null ? (
      <Col md="3" key={`env_${key}_${name}`} className='text-truncate form-label ' ><span className=' text-uppercase'>{name}</span>
        <div className='mt-2' style={{lineHeight:"25px"}}>          
            <Link to={`/healths/${key}/${name}`} onClick={(e) => checkAccessibility(e, isConfigured, showWarning) }  >
              <span className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' ? 'danger' : 'warning'}` }>
                  {' '}
                  {status ?? 'Unknow'}{' '}
              </span>
            </Link>
            <a className="material-icons-round align-bottom btn-link" href={urls[0]} target="_blank" onClick={(e) => OpenWindow(e, urls[0])} key={`env_${key}_${name}`} title="Open WebApp">public</a>
        </div>
        {statusPingdom != null ? 
          <div className='mt-2' style={{lineHeight:"25px"}}>          
            <span className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' ? 'danger' : 'warning'}` }>
                {' '}
                {status ?? 'Unknow'}{' '}
            </span>
        </div>
        : null
        }
    </Col>
    ) : (
      <Col md="3" className='text-truncate form-label ' key={`env_${key}_${name}`}><span className=' text-uppercase'>{name}</span>
        <div className='mt-2' style={{lineHeight:"25px"}}>           
            <Link to={`/healths/${key}/${name}`} onClick={(e) => checkAccessibility(e, isConfigured, showWarning) }  >
              <span className={ `rounded-pill badge-md ps-3 pe-3 pt-1 pb-1 badge badge-${status == null ? 'danger' : status === 'Healthy' ? 'discreet-success' : status === 'Unhealthy' ? 'danger' : 'warning'}` }>
                  {' '}
                  {status ?? 'Unknow'}{' '}
              </span>
            </Link>
            <a className="material-icons-round align-bottom btn-link" href={urls[0]} target="_blank" onClick={(e) => OpenWindow(e, urls[0])} key={`env_${key}_${name}`} title="Open WebApp">public</a>
        </div>
    </Col>
    )
  );
}

const formatCasing = (str: string) => {
  if (str == null) {
    return str;
  }
  return str
    .replace(/(\B)[^ ]*/g, match => (match.toLowerCase()))
    .replace(/^[^ ]/g, match => (match.toUpperCase()));
}

function dxLink(key: string): string {
  return `https://developer.sgmarkets.com/explore/webapp/${key}/information`;
}
const OpenDxWindow = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, key: any) => {
  window.open(dxLink(key), '_blank')?.focus();
  e.stopPropagation();
  e.preventDefault();
  return false;
}

const ApplicationCard: FC<ApplicationCardProps> = ({ service, refreshData, readonly, toggleBookmarks, editSettings, showWarning, statistic }: ApplicationCardProps) => {
  
  const [showTags, setShowTags] = useState<boolean>(false);

  const SetDisplayTag = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, service: ApplicationDto) => {
    e.stopPropagation();
    e.preventDefault();
    setShowTags(!showTags);
    return false;
  }
  
  return (
  <Link className='no-text-link' onClick={(e) => checkAccessibility(e, service.isConfigured, showWarning) } to={readonly || (service.status != 'Healthy' && service.status != 'Unhealthy') ? '/' : `/healths/${service.key}`}>
    <Card className='card card-bordered' >
      <CardBody className='p-4 pb-0'>
        <Row>
          <Col md="5">
              <div>
                  {readonly ? <span className="material-icons-round" style={{width: "23px"}}></span> : <span className="material-icons-round" onClick={(e) => toggleBookmarks(e, service, service.isBookmarked)} title={service.isBookmarked ? "Remove bookmark":"Add to bookmark"}>{service.isBookmarked ? 'bookmark' : 'bookmark_outline'}</span> }
                  <h5 className='header-with-icon'>{service.name}</h5>
                  <a className="material-icons-round btn-link ms-3" href={dxLink(service.key)} onClick={(e) => OpenDxWindow(e, service.key)} title="Open WebApp in Developer Portal">construction</a>
                  {service.tags.length > 0 ? <span className="material-icons-round btn-link ms-3" style={{color:"#888"}} onClick={(e) => SetDisplayTag(e, service)} title="Display Tags">label</span> : null }
              </div>
              {showTags ?
              <div style={{ paddingLeft:"30px"}} >
                {service.tags?.map((tag, index) => (
                  <span key={index} className="badge rounded-pill text-bg-secondary me-2 mb-1">{tag}</span>
                ))}
              </div> : null}
              <Row className='ps-icon'>
                  <Col className='ps-3' style={{minWidth: "250px"}}>
                  <div><label className="form-label">Department</label></div>
                  <div>{service.managerDepartment}</div>
                  </Col>
                  <Col>
                      <div><label className="form-label">Hosting</label></div>
                      <div>{formatCasing(service.hosting)}</div>
                  </Col>
                  <Col>
                    <div style={{lineHeight:"25px", textAlign:"end"}} className=' text-secondary'>Uptime:</div>
                    <div className='mt-2 text-secondary' style={{lineHeight:"25px", textAlign:"end", display: service.environments.filter((f) => f.statusPingdom != null).length > 0 ? "block" : "inline-block"}}>{service.environments.filter((f) => f.statusPingdom != null).length > 0 ? "Pingdom:": ""}</div>
                  </Col>
              </Row>
          </Col>
          <Col md="6">
              <Row>
                  {DisplayEnvironments(service.key, service.environments, service.isConfigured, showWarning)}
              </Row>
          </Col>
          <Col md="1" className='text-end'>
          {readonly || (service.status != 'Healthy' && service.status != 'Unhealthy') ? null : 
          <button className='btn btn-flat-secondary btn-xl'  onClick={(e) => editSettings(e, service)}>
            <span className={`material-icons-round ${service.isConfigured ? "text-success" : "text-danger"}`} title="Settings">settings</span>
          </button>
          }
          
          </Col>
        </Row>
        {service.status === 'Unhealthy' && service.partialIncident != null  && (
          <>
            <div>
              <span className="text-secondary">
                Partial incident: 
              </span>
            </div>
          </>
        )}
        <StatisticsSimpleUptime statistic={statistic} />
      </CardBody>
    </Card>
  </Link>
)};

export default ApplicationCard;


